import type { RingCellKind, RoadLamp, RoadState } from '@goodtime/shared';

/** True when the road's lamp of this kind is lit (Phase 1: every prize
 *  lamp; the four friend lamps stay dark). */
export function lampLit(road: Pick<RoadState, 'lamps'>, id: RingCellKind): boolean {
  return road.lamps.some((l) => l.id === id && l.lit);
}

/** The lamp a ring cell belongs to. */
export function lampFor(road: Pick<RoadState, 'lamps'>, id: RingCellKind): RoadLamp | undefined {
  return road.lamps.find((l) => l.id === id);
}

/** Side lights to light: whole lights, plus whether the next is on its way. */
export function sideLights(road: Pick<RoadState, 'ready' | 'readyMax' | 'readyProgress' | 'spinsPerLight'>): {
  lit: number;
  max: number;
  next: number;
} {
  return {
    lit: Math.min(road.ready, road.readyMax),
    max: road.readyMax,
    next: road.ready >= road.readyMax ? 0 : road.readyProgress / road.spinsPerLight,
  };
}
